import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';

import { FlatButtonComponent } from '../../shared/components/buttons/flat-button/flat-button.component';
import { IconButtonComponent } from '../../shared/components/buttons/icon-button/icon-button.component';

@Component({
  templateUrl: './updater.component.html',
  styleUrls: ['./updater.component.scss'],
  imports: [FlatButtonComponent, IconButtonComponent, MatIconModule, MatSnackBarModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class UpdaterComponent {
  constructor(private _snackBar: MatSnackBar) {}

  public update(): void {
    document.location.reload();
  }

  public close(): void {
    this._snackBar._openedSnackBarRef?.dismiss();
  }
}
